<template>
	<RouterLink v-if="to" :to="to" class="mdc-icon-button material-icons" :class="classes" :type="type" :aria-label="label" :data-aria-label-off="label" :data-aria-label-on="labelOn" v-bind="attrs">
		<div class="mdc-icon-button__ripple"></div>
		<span class="mdc-icon-button__focus-ring"></span>
		<i class="material-icons mdc-icon-button__icon mdc-icon-button__icon--on" v-html="on" v-if="on"></i>
		<i class="material-icons mdc-icon-button__icon"><slot></slot></i>
	</RouterLink>
	<a v-else-if="href" :href="href" :target="target" class="mdc-icon-button material-icons" :class="classes" :type="type" :aria-label="label" :data-aria-label-off="label" :data-aria-label-on="labelOn" v-bind="attrs">
		<div class="mdc-icon-button__ripple"></div>
		<span class="mdc-icon-button__focus-ring"></span>
		<i class="material-icons mdc-icon-button__icon mdc-icon-button__icon--on" v-html="on" v-if="on"></i>
		<i class="material-icons mdc-icon-button__icon"><slot></slot></i>
	</a>
	<button v-else class="mdc-icon-button material-icons" :class="classes" :type="type" :aria-label="label" :data-aria-label-off="label" :data-aria-label-on="labelOn" v-bind="attrs">
		<div class="mdc-icon-button__ripple"></div>
		<span class="mdc-icon-button__focus-ring"></span>
		<i class="material-icons mdc-icon-button__icon mdc-icon-button__icon--on" v-html="on" v-if="on"></i>
		<i class="material-icons mdc-icon-button__icon"><slot></slot></i>
	</button>
</template>

<script>
import tippy from 'tippy.js'

import { MDCRipple } from '@material/ripple'


export default {
	name: 'IconButton',
	props: {
		type: {
			type: String,
			default: 'button',
		},
		size: {
			type: String,
			default: 'normal',
		},
		label: {
			type: String,
			default: null,
		},
		labelOn: {
			type: String,
			default: null,
		},
		checked: {
			type: Boolean,
			default: false,
		},
		toggle: {
			type: Boolean,
			default: false,
		},
		on: {
			type: String,
			default: null
		},
		to: {
			type: Object,
			default: null,
		},
		href: String,
		target: String,
	},
	mounted() {
		const ripple = new MDCRipple(this.$el)
		ripple.unbounded = true

		tippy(this.$el, {
			theme: 'title',
			placement: 'top',
			maxWidth: '250px',
			touch: false,
			content(ref) {
				const title = ref.getAttribute('aria-label')
				ref.removeAttribute('aria-label')
				return title
			},
			onShow(instance) {
				if (!instance.props?.content?.length) return false
				return instance
			}
		})
	},
	computed: {
		attrs() {
			const atts = {...this.$attrs}
			if (this.on) {
				atts['aria-pressed'] = this.checked
			}
			return atts
		},
		classes() {
			let classes = [`mdc-icon-button--${this.size}`]
			if (this.on && this.checked) {
				classes.push(`mdc-icon-button--on`)
			}

			return classes
		},
	},
}
</script>

<style scoped lang="scss">
@use "@material/icon-button/styles";

.mdc-icon-button {
	&--small {
		font-size: 20px;
		width: 38px;
		height: 38px;
		padding: 9px;

		.material-icons {
			font-size: 20px;
		}

		.aligned & {
			margin-top: -10px;
		}
	}

	&--tiny {
		font-size: 16px;
		width: 26px;
		height: 26px;
		padding: 4px;

		.material-icons {
			font-size: 16px;
		}

		.aligned & {
			margin-top: -6px;
		}
	}

	&--smallest {
		font-size: 14px;
		width: 20px;
		height: 20px;
		padding: 2px;

		.material-icons {
			font-size: 14px;
		}
	}

	&.no-pad {
		// --mdc-ripple-fg-size: 18px;
		height: auto;
		padding: 0;
		width: auto;

		// opacity: 0.8;
		// transition: opacity 150ms linear;

		&:hover {
			opacity: 1;
		}
	}
}
</style>
